module.exports = __webpack_public_path__ + "img/ic-google.5bdd9b68.svg";